var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13344_39560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 0.75H5.25C2.76472 0.75 0.75 2.76472 0.75 5.25V18.75C0.75 21.2353 2.76472 23.25 5.25 23.25H18.75C21.2353 23.25 23.25 21.2353 23.25 18.75V5.25C23.25 2.76472 21.2353 0.75 18.75 0.75Z",
    fill: "url(#paint0_linear_13344_39560)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.94053 18.247C4.56653 18.9949 5.11046 19.875 5.94676 19.875H13.5562C14.3925 19.875 14.9364 18.9949 14.5624 18.247L10.7577 10.6375C10.3431 9.80833 9.15985 9.80833 8.74521 10.6375L4.94053 18.247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6905 18.247C11.3165 18.9949 11.8605 19.875 12.6968 19.875H18.0562C18.8925 19.875 19.4364 18.9949 19.0624 18.247L16.3827 12.8875C15.9681 12.0583 14.7848 12.0583 14.3702 12.8875L11.6905 18.247Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.625 8.62504C18.8676 8.62504 19.875 7.61764 19.875 6.375C19.875 5.13236 18.8676 4.125 17.625 4.125C16.3824 4.125 15.375 5.13236 15.375 6.375C15.375 7.61764 16.3824 8.62504 17.625 8.62504Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13344_39560",
    x1: 12,
    y1: 0.75,
    x2: 12,
    y2: 23.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8689EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0085C7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13344_39560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/Image.ddc4586f9f1718dccfb028a999690fbf.svg";
export { ForwardRef as ReactComponent };